// SVG Components - Import directly from SVG files as React components
// Using react-native-svg-transformer for clean, maintainable SVG imports

import ResioLogo from './Resio_Logo_101_34.svg';
import Hamburger from './Mobile_hamburger.svg';
import CancelX from './Cancel_X.svg';
import ArrowDropDown from './ArrowDropDownFilled.svg';
import ChevronDown from './chevron-down.svg';
import ChevronUp from './chevron-up.svg';
import AddButton from './addButton.svg';
import NotificationBell from './notificationBell.svg';
import NewEvent from './new-event.svg';
import Download from './download.svg';
import EmptyMessage from './emptyMessage.svg';
import Organization from './organization.svg';
import Property from './property.svg';
import NewUser from './new-user.svg';
import NewProperty from './new-property.svg';
import EditDot from './editDots.svg';
import EyeClosed from './eye-close.svg';
import Filter from './filter.svg';
import ChevronLeft from './chevron-left.svg';
import ChevronRight from './chevron-right.svg';
import CheckCircle from './check-circle.svg';
import XCircle from './x-circle.svg';
import EyeOpen from './eye-open.svg';
import MessageBlast from './message-blast.svg';
import Admin from './admin.svg';
import Archive from './archive.svg';
import Calendar from './calendar.svg';
import Copy from './copy.svg';
import Folder from './folder.svg';
import Warning from './warning.svg';
import Paperclip from './paperclip.svg';
import Group from './group.svg';
import Clock from '../admin/CommunityResourceIcons/clock.svg';
import Location from './location.svg';
import AttendeesTileWaveform from './attendeesTileWaveform.svg';
import RsvpsTileWaveform from './rsvpTileWaveform.svg';
import SelectResident from './selectResident.svg';
import DragIcon from './dragIcon.svg';
import ThumbUp from './thumbs-up.svg';
import Phone from './phone.svg';
import EmailSolid from './emailSolid.svg';
import Pencil from './pencil.svg';
import LargeSuccess from './largeSuccess.svg';
import Refresh from './refresh.svg';
import SendInvitation from './send-invitation.svg';
import MagnifyingGlass from './magnifyingGlass.svg';
import TRASH from './trash.svg';

// SVG Components - Direct imports from files as React components
export const SVG_COMPONENTS = {
  RESIO_LOGO: ResioLogo,
  HAMBURGER: Hamburger,
  CANCEL_X: CancelX,
  ARROW_DROP_DOWN: ArrowDropDown,
  CHEVRON_DOWN: ChevronDown,
  CHEVRON_UP: ChevronUp,
  ADD_BUTTON: AddButton,
  NOTIFICATION_BELL: NotificationBell,
  CALENDAR_EVENT: NewEvent,
  DOWNLOAD: Download,
  EMPTY_MESSAGE: EmptyMessage,
  ORGANIZATION: Organization,
  PROPERTY: Property,
  NEW_USER: NewUser,
  NEW_PROPERTY: NewProperty,
  EDIT_DOT: EditDot,
  EYE_CLOSED: EyeClosed,
  EYE_OPEN: EyeOpen,
  FILTER: Filter,
  CHEVRON_LEFT: ChevronLeft,
  CHEVRON_RIGHT: ChevronRight,
  CHECK_CIRCLE: CheckCircle,
  X_CIRCLE: XCircle,
  MESSAGE_BLAST: MessageBlast,
  ADMIN: Admin,
  ARCHIVE: Archive,
  CALENDAR: Calendar,
  COPY: Copy,
  FOLDER: Folder, 
  WARNING: Warning,
  PAPERCLIP: Paperclip,
  GROUP: Group, 
  CLOCK: Clock,
  LOCATION: Location, 
  ATTENDEES_TILE_WAVEFORM: AttendeesTileWaveform,
  RSVPS_TILE_WAVEFORM: RsvpsTileWaveform,
  SELECT_RESIDENT: SelectResident,
  DRAG_ICON: DragIcon,
  THUMB_UP: ThumbUp,
  PHONE: Phone,
  EMAIL_SOLID: EmailSolid,
  PENCIL: Pencil,
  LARGE_SUCCESS: LargeSuccess,
  REFRESH: Refresh,
  SEND_INVITATION: SendInvitation,
  MAGNIFYING_GLASS: MagnifyingGlass,
  TRASH: TRASH,
} as const;

// SVG Dimensions for consistent sizing
export const SVG_DIMENSIONS = {
  RESIO_LOGO: { width: 101.375, height: 34 },
  HAMBURGER: { width: 25, height: 26 },
  CANCEL_X: { width: 20, height: 20 },
  ARROW_DROP_DOWN: { width: 24, height: 24 },
  CHEVRON_DOWN: { width: 20, height: 20 },
  CHEVRON_UP: { width: 20, height: 20 },
  ADD_BUTTON: { width: 34, height: 34 },
  NOTIFICATION_BELL: { width: 67, height: 68 },
  CALENDAR_EVENT: { width: 67, height: 68 },
  DOWNLOAD: { width: 12, height: 12 },
  EMPTY_MESSAGE: { width: 67, height: 68 },
  ORGANIZATION: { width: 67, height: 68 },
  PROPERTY: { width: 67, height: 68 },
  NEW_USER: { width: 67, height: 68 },
  NEW_PROPERTY: { width: 67, height: 68 },
  EDIT_DOT: { width: 67, height: 68 },
  EYE_CLOSED: { width: 67, height: 68 },
  EYE_OPEN: { width: 67, height: 68 },
  FILTER: { width: 67, height: 68 },
  CHEVRON_LEFT: { width: 12, height: 12 },
  CHEVRON_RIGHT: { width: 12, height: 12 },
  CHECK_CIRCLE: { width: 12, height: 12 },
  X_CIRCLE: { width: 12, height: 12 },
  MESSAGE_BLAST: { width: 67, height: 68 },
  ADMIN: { width: 12, height: 12 },
  ARCHIVE: { width: 12, height: 12 },
  CALENDAR: { width: 12, height: 12 },
  COPY: { width: 12, height: 12 },
  FOLDER: { width: 12, height: 12 },
  WARNING: { width: 12, height: 12 },
  PAPERCLIP: { width: 12, height: 12 },
  GROUP: { width: 12, height: 12 },
  CLOCK: { width: 12, height: 12 },
  LOCATION: { width: 12, height: 12 },
  ATTENDEES_TILE_WAVEFORM: { width: 12, height: 12 },
  RSVPS_TILE_WAVEFORM: { width: 12, height: 12 },
  SELECT_RESIDENT: { width: 12, height: 12 },
  DRAG_ICON: { width: 12, height: 12 },
  THUMB_UP: { width: 67, height: 68 },
  PHONE: { width: 12, height: 12 },
  EMAIL_SOLID: { width: 12, height: 12 },
  PENCIL: { width: 12, height: 12 },
  LARGE_SUCCESS: { width: 67, height: 68 },
  REFRESH: { width: 12, height: 12 },
  SEND_INVITATION: { width: 12, height: 12 },
  MAGNIFYING_GLASS: { width: 12, height: 12 },
  TRASH: { width: 12, height: 12 },
} as const;

// Export Community Resource Icons
export * from './CommunityResourceIcons';

// Type definitions for better TypeScript support
export type SvgComponentKey = keyof typeof SVG_COMPONENTS;
export type SvgDimensionKey = keyof typeof SVG_DIMENSIONS;
